import { type FC, useCallback } from 'react';

import { SliderBlockTypeOne } from './SliderBlockTypeOne';
import { type ISliderBlockTypeOneModel } from './external/models/SliderBlockTypeOneModel';
import {
  sliderBlockTypeOneSlideServiceV1,
  sliderBlockTypeOneSlideServiceV2,
} from './internal/data/environmentForLifeAndBusinessSlideServices';
import { trackShowEnvironmentLifeBusinessSection } from './internal/tracking/trackShowEnvironmentLifeBusinessSection';
import { trackSliderBlockTypeOneChipSelect } from './internal/tracking/trackSliderBlockTypeOneChipSelect';

const ID = 'environment-for-life-and-business';
const TITLE = 'Для жизни и бизнеса';
const DESCRIPTION =
  'Продуманное благоустройство, современная инфраструктура, пространства для бизнеса и сохранение культурного наследия';

type EnvironmentForLifeAndBusinessContainerProps = {
  isDesignV2Enabled?: boolean;
};

/**
 * @description Контейнер для блока "Среда для жизни и бизнеса".
 */
export const EnvironmentForLifeAndBusinessContainer: FC<EnvironmentForLifeAndBusinessContainerProps> = ({
  isDesignV2Enabled = false,
}) => {
  const sliderBlockTypeOneSlideService = isDesignV2Enabled
    ? sliderBlockTypeOneSlideServiceV2
    : sliderBlockTypeOneSlideServiceV1;
  const description = isDesignV2Enabled ? '' : DESCRIPTION;

  const handleShow = useCallback(
    () => trackShowEnvironmentLifeBusinessSection(sliderBlockTypeOneSlideService, ID),
    [sliderBlockTypeOneSlideService],
  );

  const handleChipSelect = useCallback(
    (sliderBlockTypeOneModel: ISliderBlockTypeOneModel) =>
      trackSliderBlockTypeOneChipSelect(TITLE, ID, sliderBlockTypeOneModel),
    [],
  );

  return (
    <SliderBlockTypeOne
      description={description}
      id={ID}
      sliderBlockTypeOneSlideService={sliderBlockTypeOneSlideService}
      title={TITLE}
      isDesignV2Enabled={isDesignV2Enabled}
      onChipSelect={handleChipSelect}
      onShow={handleShow}
    />
  );
};
